import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LineSeperator from '../ui/LineSeperator';
import eventImg from '../../assets/SchoolEvent.jpg';
import audiImg from '../../assets/SchoolEventAudi.jpg';
import otherImg from '../../assets/SchoolEventOthr.jpg';
import buildingImg from '../../assets/SchoolBuilding.jpg';
import '../../stylings/Gallery.css';

const fallbackAlbums = [
  { _id: 'g1', title: 'Annual Day 2024', coverImage: audiImg, count: 24 },
  { _id: 'g2', title: 'Sports Day 2024', coverImage: eventImg, count: 18 },
  { _id: 'g3', title: 'Science Exhibition', coverImage: otherImg, count: 30 },
  { _id: 'g4', title: 'School Campus', coverImage: buildingImg, count: 15 },
  { _id: 'g5', title: 'Cultural Program', coverImage: audiImg, count: 22 },
  { _id: 'g6', title: 'Republic Day', coverImage: eventImg, count: 12 },
];

export default function Gallery() {
  const albums = useSelector((state) => state.photoGallery.albums);
  const displayAlbums = albums.length > 0 ? albums.slice(0, 6) : fallbackAlbums;

  return (
    <section className="gallery-section">
      <div className="container-fluid px-5">
        <LineSeperator title="Photo Gallery" />
        <div className="gallery-grid">
          {displayAlbums.map((album, i) => (
            <Link
              key={album._id}
              to={`/gallery/${album._id}`}
              className={`gallery-item gallery-item-${(i % 6) + 1}`}
            >
              <img
                src={album.coverImage || album.images?.[0] || fallbackAlbums[i % 6].coverImage}
                alt={album.title}
                className="gallery-img"
              />
              <div className="gallery-overlay">
                <h5 className="gallery-album-title">{album.title}</h5>
                <span className="gallery-count">
                  <i className="fas fa-images me-1"></i>
                  {album.count || album.images?.length || '–'} Photos
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-4">
          <Link to="/galleryall" className="section-view-all-btn">View All Albums</Link>
        </div>
      </div>
    </section>
  );
}
